<template>
  <div class="getCouponCenterPage">
    <XR-head titleText="领券中心" ref="headObj"></XR-head>
    
      <div class="coupon_center_v2_nav">
        <div class="nav">      
          <ul :style="{ width: ulWidth+'px'}">
            <template v-for="(item,index) in CategoryNavList"  >
              <li v-if="item.FatherId==0 && item.TypeId==1" :key="index"
               @click="itemClick(item.TypeValue,index)" :class="{active:ins==index}">
                  <a href="javascript:;">
                    <mu-flat-button :label="item.Name" class="demo-flat-button"/>
                  </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">
      <div class="coupon_banner_bg">
          <img src=" ../static/coupon/4.png" alt="">
      </div>
      
      <div class="coupon_sec_body">
          <div  v-for="couponRow in couponList" :key="couponRow.id" class="coupon_default_inner"> 
            <template > 
              <div :class="(percent(couponRow.ReceiveAmount/couponRow.TotalAmount) >=100 ? 'couponGrey' : (couponRow.Type== 0? 'couponRink':'couponYellow'))" class="couponLeft" >
                  <div class="coupon_discount" >
                      <p class="cost">￥</p>
                      <p class="money">{{couponRow.Money}}</p>
                  </div>
              </div>
              <div class="couponRight" :class="(percent(couponRow.ReceiveAmount/couponRow.TotalAmount)>=100 ? 'couponGrey' : (couponRow.Type==0? 'couponRink':'couponYellow'))">              
                <div class="coupon_content" :style="{width:couponWidth+'px'}">
                  <p class="coupon_title">
                    <span class="coupon_type">{{couponRow.TypeName}}</span> {{couponRow.Name}}
                  </p>
                  <p class="limit">
                      使用门槛：满{{couponRow.FullMoney}}元可用
                      <span v-if="couponRow.ReceiveStatus==1" style="float: right;margin-right: 14px;">已领取</span>
                  </p>
                  <div class="coupon_progress">
                    <mu-linear-progress mode="determinate" :value="percent(couponRow.ReceiveAmount/couponRow.TotalAmount)"/>
                    <span class="percent">{{percent(couponRow.ReceiveAmount/couponRow.TotalAmount)+'%'}}</span>
                    <mu-flat-button  v-if="percent(couponRow.ReceiveAmount/couponRow.TotalAmount) !=100 && couponRow.ReceiveStatus==0" @click="btnClick(couponRow.Id)" label="点击领取" class="demo-flat-button" primary/>
                    <mu-flat-button  v-if="couponRow.ReceiveStatus==1" label="去使用" class="demo-flat-button" primary/>
                    <span v-if="percent(couponRow.ReceiveAmount/couponRow.TotalAmount)==100 && couponRow.ReceiveStatus==0" class="coupon_empty">已抢光</span>
                  </div>                 
                </div>
              </div>
            </template>
          </div>
      </div>
    </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<script>
export default {
  data(){
    return{
      couponInfo:{
        CategoryId:'',
        pageIndex : 0,
      },
      pageEnd : 0, // 结束页数
      num:15,
      ins:0,
      couponList:[],
      ulWidth: document.documentElement.clientWidth-99,
      CategoryNavList:[],
      couponWidth: document.documentElement.clientWidth-20-60-16,
      scrollDone:function(){},
    }
  },
  mounted:function(){
    this.GetShoppingCategoryNavList()
    this.WapCouponList(true)
  },
  methods: {
    GetShoppingCategoryNavList(){
      var ths = this
      ths.$post('/Shop/RetailServer/GetShoppingCategoryNavList'
        ).then(function (res) {
          if(res.IsSuccess){
            ths.CategoryNavList = res.Data
            ths.CategoryNavList.unshift({TypeValue:'',Name:'全部',FatherId:0,TypeId:1,CategoryId:''})
          }else{
            ths.$refs.XRtoast.failed(res.Msg)
          }
        })        
    },
    WapCouponList(isNewSearch){
      this.$refs.XRtoast.load()
      if(isNewSearch){        
        this.couponInfo.pageIndex=1
      }
      else{
        this.couponInfo.pageIndex++
      }
      var ths = this;

      ths.$post('/Shop/CouponServer/WapCouponList',
        JSON.stringify(this.couponInfo)
      ).then(function (res){
        ths.scrollDone()
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          if(isNewSearch){
            ths.couponList = []    
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRtoast.failed(res.Msg, true)    
          }
          
        }else{
          if(isNewSearch){
            ths.couponList = res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.couponList.push(res.Data.List[i])
            }
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
          if(ths.couponList.length <= 0){            
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRPageTip.initTip()
          }
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.couponInfo.pageIndex+1 > this.pageEnd){
       
        //this.$refs.XRtoast.failed("已经到最后一页", true)\
        this.$refs.scroll.infiniteDone()
        return
      }
      this.WapCouponList(false);     
    },
    percent(obj){
      return (obj * 100).toFixed(2);
    },
    itemClick(CategoryId,index){
       this.ins = index
       this.couponInfo.CategoryId = CategoryId
       this.WapCouponList(true)
    },
    btnClick(num){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
        return;
      }else{
        var ths = this;
        ths.$post('/Shop/CouponServer/WapReceiveCoupon',{'CouponId':num}
        ).then(function (res) {
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg)
          }else{
            ths.WapCouponList(true)
          }
          })
      }
    }
  }
}
</script>
<style>
  .getCouponCenterPage{
    margin: 0;
  }
  .getCouponCenterPage .xr-pageTip{
    padding: 0;
    margin-top: 100px;
  }
  .getCouponCenterPage .coupon_center_v2_nav{
    position: relative;
    overflow: hidden;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav{
    overflow: auto;
    background: #fff;
    height: 45px;
    padding-left: 64px;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav li{
    list-style: none;
    display: inline-block;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav li:first-child{
    position: absolute;
    left: 0;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav li.active .mu-flat-button .mu-flat-button-label{
    border-bottom: 2px solid red;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav .hold{
    float: left;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav li .mu-flat-button{
    min-width: 64px;
    height: 45px;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav li .mu-flat-button .mu-flat-button-label{
    line-height: 45px;
    height: 45px;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav ul{
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
    overflow-x: auto;
    float: left;
  }
  .getCouponCenterPage .coupon_center_v2_nav .nav ul::-webkit-scrollbar {
    display: none;
  }
  .getCouponCenterPage .coupon_banner_bg{
    width: 100%;
  }
  .getCouponCenterPage .coupon_banner_bg img{
    width: 100%;
    display: block;
  }
  .getCouponCenterPage .coupon_sec_body{
    width: 100%;
    padding: 0 10px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner{
    width: 100%;
    display: flex;
    margin-top: 10px;
    background-size: 100% 100%; 
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner:first-child{
    margin-top: 0;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponLeft{
    padding: 10px 0;
    background-size:100% 100%; 
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponLeft .coupon_discount{
    width: 60px;
    height: 60px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    margin: 0 8px;
    margin-top: 8px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponLeft.couponGrey .coupon_discount{
    background: #999;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponLeft.couponRink .coupon_discount{
    background: #E95E88;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponLeft.couponYellow .coupon_discount{
    background: orange;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .coupon_discount .cost{
    height: 20px;
    line-height: 30px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .coupon_discount .money{
    font-size: 26px;
    height: 30px;
    line-height: 30px;
  }  
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight{
    background-image: url('/static/coupon/couponCenter2.png'); 
    background-size:100% 100%; 
    padding: 10px 0;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content{
    padding: 0 8px;
    border-left: 1px dotted #999;
    
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 25px;
    line-height: 23px;
    font-size: 16px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title .coupon_type{
    padding: 2px 5px;
    border-radius: 3px;
    font-size: 12px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_content .coupon_title .coupon_type{
    border: 1px solid #999;
    color: #999;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_content .coupon_title .coupon_type{
    border: 1px solid #E95E88;
    
    color: #E95E88;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_content .coupon_title .coupon_type{
    border: 1px solid orange;
    color: orange;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .limit{
    font-size: 12px;
    color: #666;
    margin: 5px 0 10px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .coupon_progress{
    display: flex;
    align-items: center;
    position: relative;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .coupon_progress span{
    width: 50px;
    padding-left: 5px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_progress span.percent{
    color: #999;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_progress span.percent{
    color: #E95E88;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_progress span.percent{
    color: orange;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner  .coupon_progress .mu-linear-progress{
    width: 40%;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: #999;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: #E95E88;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: orange;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .coupon_progress .mu-flat-button{
    width: 64px;
    min-width: 64px;
    height: 26px;
    background: red;
    color: #fff;
    position: absolute;
    right: 0;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .coupon_progress .coupon_empty{
    position: absolute;
    width: 64px;
    text-align: center;
    right: 0;
    font-size: 12px;
  }
  .getCouponCenterPage .coupon_sec_body .coupon_default_inner .coupon_progress .mu-flat-button .mu-flat-button-label{
    font-size: 12px;
    padding: 0;
  }
  .getCouponCenterPage .btn-list{
  width: 100%;
  position: fixed;
  bottom: 0;
}
.getCouponCenterPage .btn-list .btn{
  float: left;
  width: 50%;
  background: #FF9500;
  text-align: center;
  color:white;
  height: 56px;
  line-height: 56px;
}
.getCouponCenterPage .btn-list .btn ~ .btn{
  background: #FF0036;
}
.getCouponCenterPage .couponGrey{
  background: url('/static/coupon/couponCenter1-2.png');
}
.getCouponCenterPage .couponRink{
  background: url('/static/coupon/couponCenter1.png');
}
.getCouponCenterPage .couponYellow{
  background: url('/static/coupon/couponCenter1-3.png');
}
.getCouponCenterPage .yo-scroll{
  top: 101px;
}
</style>





// WEBPACK FOOTER //
// src/pages/retail/coupon/getCouponCenter.vue